export default "__VITE_ASSET__CjyWrFjs__"